import { combineReducers } from 'redux';
import { modalsReducer } from '@xbcb/ui-utils';

export default combineReducers({ modals: modalsReducer });
